module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/baby-7878c0294191030622dc45c07f838db9.jpg";